import { render, staticRenderFns } from "./courseType.vue?vue&type=template&id=397910f0&scoped=true"
import script from "./courseType.vue?vue&type=script&lang=ts"
export * from "./courseType.vue?vue&type=script&lang=ts"
import style0 from "./courseType.vue?vue&type=style&index=0&id=397910f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397910f0",
  null
  
)

export default component.exports